module.exports = __webpack_public_path__ + "img/is.d9ed75b9.svg";